/* unplugin-vue-components disabled */import { render } from "./DNASequenceRender.vue?vue&type=template&id=a389496a&scoped=true"
import script from "./DNASequenceRender.vue?vue&type=script&lang=js"
export * from "./DNASequenceRender.vue?vue&type=script&lang=js"

import "./DNASequenceRender.vue?vue&type=style&index=0&id=a389496a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a389496a"]])

export default __exports__